/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemFinancialsSchema } from './itemFinancialsSchema';

export const bulkItemFinancialsResponseSchema = z.object({
  get financials() {
    return z.array(itemFinancialsSchema);
  },
});
